import { render, staticRenderFns } from "./DataIteratorFooter.vue?vue&type=template&id=3f5d57de&scoped=true"
import script from "./DataIteratorFooter.vue?vue&type=script&lang=js"
export * from "./DataIteratorFooter.vue?vue&type=script&lang=js"
import style0 from "./DataIteratorFooter.scss?vue&type=style&index=0&id=3f5d57de&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5d57de",
  null
  
)

export default component.exports